import React from 'react'
import { graphql } from 'gatsby'
import { Container } from 'theme-ui'
import Layout from '@solid-ui-layout/Layout'
import Seo from '@solid-ui-components/Seo'
import Divider from '@solid-ui-components/Divider'
import ModalWithTabs from '@solid-ui-blocks/Modal/Block01'
import ModalSimple from '@solid-ui-blocks/Modal/Block02'
import Header from '@solid-ui-blocks/Header/Block02'
import Hero from '@solid-ui-blocks/Hero/Block04'
import Content from '@solid-ui-blocks/Content/Block01'
import Footer from '@solid-ui-blocks/Footer/Block01'
import LearnMore from '@solid-ui-blocks/CallToAction/Block02'
import { normalizeBlockContentNodes } from '@blocks-helpers'
import styles from './_styles'
import theme from './_theme'
const IntroductiontoApplayio = props => {
  const { allBlockContent } = props.data
  const content = normalizeBlockContentNodes(allBlockContent?.nodes)

  return (
    <Layout theme={theme}{...props}>
      <Seo title='Introduction' keywords='Hospitality, tv entertainment, pay tv' pageDescription='Applay.io is a 5 star Hospitality In Room Tv entertainment & engagement system for all hospitality operators'/>
      {/* Modals */}
      <ModalWithTabs content={content['information']} />
      {/* Blocks */}
      <Header content={content['header']} />
      <Container variant='full' sx={styles.heroContainer}>
        <Hero content={content['hero']} reverse />
      </Container>
      <Divider space='5' />
      <Content content={content['content-one']}/>
      <Divider space='5' />
      <LearnMore content={content['contentprovider']} />
      <Divider space='1'/>
      <LearnMore content={content['propertyaccount']} />
      <Divider space='5' />
      <Footer content={content['footer']} />
    </Layout>
  )
}

export const query = graphql`
  query innerpageIntroductiontoApplayioBlockContent {
    allBlockContent(
      filter: { page: { in: ["innerpage/introduction-to-applay-io", "shared"] } }
    ) {
      nodes {
        ...BlockContent
      }
    }
  }
`

export default IntroductiontoApplayio
